import _ from 'lodash';
import { Organization } from './organization';

export class User {
  username: string;
  organization: Organization;
  securityGroups: string[];
  givenName: string;
  familyName: string;
  fullName: string;
  email: string;
  phone: string;

  isAdmin: boolean;
  isMxAdmin: boolean;
  isOrgAdmin: boolean;
  isFacAdmin: boolean;
  
  initialize() {
    this.fullName = this.givenName + ' ' + this.familyName;
    this.setUserAdminLevel();
  }

  toString(): string {
    return JSON.stringify(this);
  }

  getFirstFacilityCode(): string {
    const securityGroup = _.find(this.securityGroups, group => {
      return group.startsWith('facility-');
    });
    if (securityGroup) {
      return securityGroup.split('-')[1];
    }
    return '';
  }

  private setUserAdminLevel() {
    if (_.indexOf(this.securityGroups, 'app-access-mxadmin') > -1) {
      this.isMxAdmin = true;
    } else {
      if (_.indexOf(this.securityGroups, 'app-access-participantadmin') > -1 ||
          _.indexOf(this.securityGroups, 'app-notify-participantadmin') > -1) {
        let facCount = 0;
        _.forEach(this.securityGroups, group => {
          if (group.startsWith('facility-')) {
            facCount++;
          }
        });
        if (facCount === 1) {
          this.isFacAdmin = true;
        } else if (facCount > 1) {
          this.isOrgAdmin = true;
        }
      }
    }

    this.isAdmin = this.isMxAdmin || this.isOrgAdmin || this.isFacAdmin;
  }
}
